<section class="d-f fd-c jc-sb md {{ asAlert ? 'alert' : '' }}">
	<div class="pt-xxxs pb-xxxs pr-xxs pl-xxs d-f jc-sb ai-c md__header">
		<h2>{{ modalTitle }}</h2>
		<button
			mat-icon-button
			aria-label="Close modal"
			(click)="dialogClose.emit()"
		>
			<mat-icon svgIcon="sanus-closeb"></mat-icon>
		</button>
	</div>
	<div
		class="mt-xxs mb-xxs d-f fd-c jc-fs oy-a md__body {{
			noMargins ? 'no-margins' : ''
		}}"
	>
		<ng-content></ng-content>
	</div>
	<div
		class="pt-xxxs pb-xxxs pr-xxs pl-xxs d-f ai-c jc-fe {{
			asAlert ? '' : 'fixed-footer'
		}} md__footer"
		*ngIf="!hideFooter"
	>
		<button
			class="p-quark mr-xxs"
			id="close-button"
			mat-stroked-button
			color="primary"
			(click)="dialogClose.emit()"
			*ngIf="secButton"
		>
			{{ secTitleButton }}
		</button>
		<button
			class="p-quark"
			mat-flat-button
			color="primary"
			[disabled]="disabled"
			(click)="dialogSave.emit()"
		>
			{{ titleButton }}
		</button>
	</div>
</section>
